import React from 'react';
import imgBetType1 from '../../../assets/images/Group 34257.svg';
import imgBetType2 from '../../../assets/images/Group 34318.svg';
import { TableTypes } from '../../../enums/tableTypes';

export const MobileSwitchTable = ({ mainTableType, setMainTableType }) => {
  return (
    <div className={`bet-container-type ${mainTableType === TableTypes.Rectangle ? 'type2' : 'type1'}`}
         onClick={() =>
           setMainTableType(
             mainTableType === TableTypes.Rectangle
               ? TableTypes.Oval
               : TableTypes.Rectangle,
           )
         }
    >
      <img src={imgBetType1} alt=""/>
      <img src={imgBetType2} alt=""/>
    </div>
  );
};
